import images from "./images";

const About = {
    sub: "About Us",
    heading: "Drive with Confidence, Rent with EliteCars",
    description: "EliteCars is your reliable choice for premium and affordable car rentals. Whether it’s for airport transfers, business travel, or special occasions, we provide a wide range of well-maintained vehicles to meet your needs. Experience hassle-free booking, 24/7 support, and the best price guarantee — all in one place.",
    image: {
        src: images.about,
        alt: "Luxury Car Rental",
    },
    button: {
        text: "Discover More",
        link: "Car-Grid"
    }
};

export default About;